import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { getAuthenticationRedirectUrl } from "../utils/redirectUtils";
import { forwardAuthLinkError } from "../utils/authLinkError";

const ProtectedRoute = ({ children }) => {
  const { user, loading, profileLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      const currentPath = `${location?.pathname || "/"}${location?.search || ""}`;
      const authUrl = forwardAuthLinkError(getAuthenticationRedirectUrl(currentPath), location);
      navigate(authUrl, { replace: true });
    }
  }, [user, loading, navigate, location]);

  // Wait for both auth AND profile to finish loading
  if (loading || (user && profileLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dm-page">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent mx-auto mb-4"></div>
          <p className="text-dm-text-2 font-medium">
            Loading your dashboard...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dm-page">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent mx-auto mb-4"></div>
          <p className="text-dm-text-2 font-medium">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
